export const UNAUTHORIZED = 1;
export const AUTHORIZED_AS_APPLICATION = 2;
export const AUTHORIZED_AS_USER = 3;

export const ROLE_BCBA = 'bcba';
export const ROLE_INDEPENDENT_CURATOR = 'independent_curator';
export const ROLE_CURATOR = 'curator';
export const ROLE_THERAPIST = 'therapist';
export const ROLE_CLIENT = 'client';

export const SUBSCRIPTION_MIN_DAYS_LEFT_FOR_WARNING = 7;



// WEBPACK FOOTER //
// ./src/common/auth/constants.js